/**
 * @file 避免线上环境打出日志
 */
import { customFormatDateTime } from './@datetime';

export enum Level {
    LOG,
    INFO,
    WARN,
    ERROR,
    NOTHING,
}

export class Log {
    public static isProduction: boolean = false;
    private _level: Level = Level.LOG;
    constructor(private name: string) {}

    public set level(level: Level) {
        this._level = level;
    }

    public error = (...otherParams: any[]) => this._display(Level.ERROR, otherParams);
    public info = (...otherParams: any[]) => this._display(Level.INFO, otherParams);
    public warn = (...otherParams: any[]) => this._display(Level.WARN, otherParams);
    public log = (...otherParams: any[]) => this._display(Level.LOG, otherParams);

    private _display(level: number, otherParams: any[]) {
        if (Log.isProduction || this._level > level) {
            return this;
        } else {
            const date = customFormatDateTime(new Date(), 'hh:mm:ss');
            otherParams.unshift(`${this.name}: [${date}]`);
            const method = Level[level].toLowerCase() as keyof Console;
            // @ts-ignore
            console[method].apply(console, otherParams);
            return this;
        }
    }
}
